import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import AppRoutes from "./App";

ReactDOM.render(
    <AppRoutes />,
  document.getElementById("root"),
);
